import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import {
  setSnapEBTData,
  cartPaid,
} from "../../ReduxToolkit/Reducers/CartReducer";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";

export default function SnapEBTSuccess() {
  const {
    applyTax: applyTaxState,
    tax,
    cartItems,
    total,
    discount,
    redeemedPointsValue,
    register_id,
  } = useSelector((state) => state.cart);
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const subtotal = cartItems.reduce(
    (acc, item) => acc + item.price * item.quantity,
    0
  );

  useEffect(() => {
    // Retrieve query parameters from the URL
    const searchParams = new URLSearchParams(location.search);
    const encoded_resp_data = searchParams.get("resp_data");

    const message = searchParams.get("message");

    // If response data is missing, redirect to the payment failed page
    if (!encoded_resp_data) {
      console.error("Missing response data.");
      // navigate("/payment-failed");
      return;
    }

    try {
      // Decode the response data from base64 and parse it
      const decoded_resp_data = JSON.parse(atob(encoded_resp_data));

      // Dispatch actions to finalize the cart
      if (decoded_resp_data && decoded_resp_data.xAuthCode) {
        console.log(decoded_resp_data);
        dispatch(setSnapEBTData(decoded_resp_data));
        dispatch(cartPaid());
        // handlePrintInvoice(); // Save order and trigger invoice in a new tab
        toast.success(message || "Payment successful!");
        navigate("/pos"); // Redirect to the POS page or any other appropriate route
      } else {
        console.error("Invalid response data.");
        navigate("/payment-failed");
      }
    } catch (error) {
      console.error("Failed to decode response data:", error);
      navigate("/payment-failed");
    }
  }, [location, dispatch, navigate]);

  const handlePrintInvoice = () => {
    const order = {
      items: cartItems,
      sale_amount: subtotal,
      discount: discount,
      tax: tax,
      paid: total,
      tax_apply: applyTaxState,
      redeem_points_value: redeemedPointsValue,
      customer_id: 0,
      register_id: register_id,
    };

    // Save order in localStorage
    localStorage.setItem("latestOrder", JSON.stringify(order));

    // Show the Swal confirmation popup
    Swal.fire({
      title: "Print Invoice?",
      text: "Would you like to print the invoice?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, print it!",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.isConfirmed) {
        // Open invoice page in new tab
        const newWindow = window.open(
          "/invoice",
          "_blank",
          "noopener,noreferrer"
        );
        if (newWindow) {
          // Focus on the new tab if possible
          newWindow.focus();

          // Trigger print after a slight delay to allow the page to load
          setTimeout(() => {
            newWindow.print();
          }, 500); // Delay for print popup to ensure page load
        }
      }
    });
  };

  return <div>Finalizing SNAP/EBT Payment...</div>;
}
